"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PARSER_INPUT_TYPE = exports.DEVERO_TYPE = exports.BROWSERS = exports.EmrType = exports.DEFAULT_COUNTRY_CODE = void 0;
exports.DEFAULT_COUNTRY_CODE = "+1";
var EmrType;
(function (EmrType) {
    EmrType["KINNSER"] = "KINNSER";
    EmrType["KINNSER_THERAPY"] = "KINNSER_THERAPY";
    EmrType["AXXESS"] = "AXXESS";
    EmrType["AXXESS_HOME_CARE"] = "AXXESS_HOME_CARE";
    EmrType["AXXESS_HOSPICE"] = "AXXESS_HOSPICE";
    EmrType["DEVERO"] = "DEVERO";
    EmrType["KINNSER_HOSPICE"] = "KINNSER_HOSPICE";
    EmrType["KANTIME"] = "KANTIME";
    EmrType["NOTEEFIED"] = "NOTEEFIED";
    EmrType["DATA_SOFT_LOGIC"] = "DATA_SOFT_LOGIC";
    EmrType["SYNERGY_EMR"] = "SYNERGY_EMR";
    EmrType["CARE_PORTAL"] = "CARE_PORTAL";
    EmrType["HOME_HEALTH_MD"] = "HOME_HEALTH_MD";
    EmrType["HOSPICE_MD"] = "HOSPICE_MD";
    EmrType["ALORA_PLUS"] = "ALORA_PLUS";
    EmrType["NDOC"] = "NDOC";
    EmrType["ALLEGHENY"] = "ALLEGHENY";
    EmrType["CAREFICIENT"] = "CAREFICIENT";
    EmrType["DATA_SOFT_LOGIC_HOSPICE"] = "DATA_SOFT_LOGIC_HOSPICE";
    EmrType["DEVERO_MIHH"] = "DEVERO_MIHH";
    EmrType["E_CLINICAL_WORKS"] = "E_CLINICAL_WORKS";
    EmrType["HOMECARE_HOMEBASE"] = "HOMECARE_HOMEBASE";
    EmrType["MY_IGEA"] = "MY_IGEA";
    EmrType["KANTIME_HOMECARE"] = "KANTIME_HOMECARE";
    EmrType["KANTIME_HOSPICE"] = "KANTIME_HOSPICE";
    EmrType["ON_DEMAND_HOMECARE"] = "ON_DEMAND_HOMECARE";
    EmrType["VEERTUALTECH"] = "VEERTUALTECH";
    EmrType["DEVERO_INFINITY"] = "DEVERO_INFINITY";
    EmrType["HOSPICE_TOOLS"] = "HOSPICE_TOOLS";
    EmrType["MATRIX_CARE"] = "MATRIX_CARE";
})(EmrType || (exports.EmrType = EmrType = {}));
exports.BROWSERS = {
    CHROME: "CHROME",
    FIREFOX: "FIREFOX",
};
var DEVERO_TYPE;
(function (DEVERO_TYPE) {
    DEVERO_TYPE["EDITABLE"] = "EDITABLE";
})(DEVERO_TYPE || (exports.DEVERO_TYPE = DEVERO_TYPE = {}));
exports.PARSER_INPUT_TYPE = {
    FIRST_NAME: "FIRST NAME",
    LAST_NAME: "LAST NAME",
    ADDRESS: "ADDRESS",
    MI: "MI",
    ALT_PHONE: "ALT-PHONE",
    PHONE: "Phone",
    DOB: "DOB",
    INSURANCE: "Insurance",
    PERSONAL_INFO: "Personal Information",
    EMERGENCY_CONTACT_EC: "Emergency Contact (EC)",
    PHYSICIAN_INFO: "Physician Information",
    PAGE: "Page",
    DATES_OF_SERVICE: "Dates of Service",
    CONFIDENTIALITY_NOTICE: "CONFIDENTIALITY NOTICE",
    COMMENTS: "COMMENTS",
    SELF: "SELF",
    DIFFERENT_OFFFICE: "Different Office",
    PHARMACY: "Pharmacy",
    PRIM_PHONE: "PRIM-PHONE",
    PRIM: "PRIM",
    VALID_TILL_PRIMARY: "VALID TILL\nPrimary",
    PATIENT_CHOICE: "PATIENT\nCHOICE",
    ONE_PHARMACY: "1	Pharmacy",
    PHONE_BREAK: "Phone: ",
    SEPERATOR_SYMBOL: "|",
    FAX: "Fax",
    ALLERGIES: "Allergies",
    AR_OR_EC: "AR/EC",
    CELL: "CELL",
    PHARMACY_MAIN: "PHARMACY MAIN",
    DME: "DME",
    ADMISSION_PROFILE_FOR: "Admission Profile\nfor",
    REGION: "Region",
    LANGUAGE: "Language",
    ADMIT_DATE: "Admit Date",
    M: "M",
    PHYSICIAN: "Physician",
    REFERRAL: "Referral",
    SOURCE: "Source",
    REFERRAL_DATE: "Referral Date",
    REFERRAL_SOURCE: "Referral\nSource:",
    HOME_PHONE: "Home Phone:",
    DISCHARGE_DATE: "Discharge Date:",
    ErrorSSN: "#ErrorSSN",
    ERRORDOB: "#Error DOB",
    OPEN_CIRCLE: "(",
    FAMILY_MEDICINE: "Family Medicine",
    PATIENT_INFO: "PATIENT INFORMATION",
    DATE_LAST_SEEN: "DATE LAST SEEN",
    RESPONSIBLE_PARTY: "RESPONSIBLE PARTY",
};
